import React from 'react'
import { TemplateHeader } from './WorkspaceTemplate/TemplateHeader'
// import SplitPane from 'react-split-pane'
import cx from 'classnames'
import style from './style.scss'
import { Menu } from './WorkspaceTemplate/Menu'
import { StatusBar } from './WorkspaceTemplate/StatusBar'
import EnablexLogo from '~/../public/images/enablexLogo.png'
import { Bots } from './Bots'


export const WorkspaceTemplate = ({config}) => {
    return <>
        <div className={style.templateWrapper}>
            <div className={cx('bp-sa-wrapper', style.mainLayout)}>
                <Menu config={config} />
                <div className={style.container}>
                    <TemplateHeader logo={config.logoURL ? config.logoURL : EnablexLogo} workspaceId={config.workspaceId} isLogoAvailable={config.isLogoAvailable} />
                    {/* <SplitPane
                        split='horizontal'
                        defaultSize={lastSize}
                        onChange={size => size > 100 && localStorage.setItem(splitPanelLastSizeKey, size.toString())}
                        size={bottomBarSize}
                        maxSize={-100}
                        className={cx(style.mainSplitPaneWToolbar)}
                    > */}
                    <div className={cx('bp-sa-content-wrapper', style.main)}>
                        {/* {props.children} */}
                        <Bots config={config} />
                    </div>
                    {/* <BottomPanel /> */}
                    {/* </SplitPane> */}
                </div>
            </div>

            <StatusBar />
        </div>
    </>
}
